import Vue from 'vue'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import SimpleSingleselect from '../../component/simple-form/singleselect.vue'
import TextInput from '../../component/dccore-form/textInput.vue'
import NumberInput from '../../component/dccore-form/numberInput.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'
import timePicker from '../../component/timePicker.vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import Geocoder from '../geocoder'
import History from './history.vue'

const GOOGLE_API_KEY = GOOGLE_GEOCODE_API_KEY

if ($('#address_show').length) {
  Vue.use(VueResource)

  Vue.use(VueGoogleMaps, {
    load: {
      key: GOOGLE_API_KEY,
    },
  })

  Vue.use(Geocoder, {
    googleMapsApiKey: GOOGLE_API_KEY
  })

  new Vue({
    el: '#address_show',
    components: {
      RingLoader,
      Multiselect,
      TextInput,
      NumberInput,
      Singleselect,
      Checkbox,
      timePicker,
      SimpleSingleselect,
      History
    },
    mixins: [mixins],
    data: {
      loading: 0,
      address: {
        x: 52.23682205,
        y: 21.0570343800358,
      },
      isMapCalling: false,
      mapLocation: null,
      displayName: '',
      markers: null,
      marker: null,
      zoom: 18,
      canChangeCords: false,
      intercomName: null,
      companyName: null,
    },
    computed: {
      position: function () {
        return {
          lat: this.address.x,
          lng: this.address.y
        }
      }
    },
    mounted: function () {
      this.loading++
      this.loading--
      this.address.x = parseFloat($('#address-x').val())
      this.address.y = parseFloat($('#address-y').val())
    }
  })
}
